"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const Tooltip_1 = tslib_1.__importDefault(require("@mui/material/Tooltip"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const styles_1 = require("@mui/material/styles");
const SeverityTag_1 = tslib_1.__importDefault(require("../SeverityTag/SeverityTag"));
const icons_1 = require("../icons");
/**
 * This component displays the customer's notification policy, which includes a list of case categories with the severity that belongs to each type of case.
 * If the customer's policy differs from mnemonic's default policy, an orange info icon and tooltip are shown.
 * This component is not a stand alone component. It needs to have a wrapper around it taking care of errors.
 *
 * @category component
 */
const NotificationPolicyContainer = (props) => {
    const { standardPolicy, customerPolicy, policyDescriptor, tooltipText, toText } = props;
    const theme = (0, styles_1.useTheme)();
    const { tooltipText: defaultTooltipText } = (0, styles_1.useThemeProps)({
        props,
        name: "NotificationPolicyContainer",
    });
    const { toText: defaultToText } = (0, styles_1.useThemeProps)({
        props,
        name: "SeverityTag",
    });
    const isDefaultStandard = (customerSeverity, defaultSeverity) => {
        return customerSeverity === defaultSeverity;
    };
    const tooltipContent = (severity) => {
        return `${(toText ? toText(severity) : defaultToText(severity)).toUpperCase()} ${tooltipText ? tooltipText : defaultTooltipText}`;
    };
    return (react_1.default.createElement("div", null, Object.entries(customerPolicy).map(([category, severity]) => (react_1.default.createElement(material_1.Box, { key: category, display: "flex", alignItems: "center", mb: 1, borderBottom: `1px solid ${theme.palette.divider}`, justifyContent: "space-between", pb: 1, width: "100%" },
        react_1.default.createElement(Typography_1.default, { variant: "body2" }, policyDescriptor[category]),
        react_1.default.createElement(material_1.Box, { display: "flex", flexDirection: "row" },
            react_1.default.createElement(SeverityTag_1.default, { severity: severity }),
            !isDefaultStandard(severity, standardPolicy[category]) && (react_1.default.createElement(material_1.Box, { display: "flex", alignItems: "center" },
                react_1.default.createElement(Tooltip_1.default, { title: react_1.default.createElement(Typography_1.default, null, tooltipContent(severity)) },
                    react_1.default.createElement(icons_1.ErrorIcon, { color: "secondary", sx: {
                            height: "20px",
                            marginLeft: "4px",
                            width: "20px",
                        } }))))))))));
};
exports.default = NotificationPolicyContainer;
